import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleDropdownComponent } from './role-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [RoleDropdownComponent],
  exports: [RoleDropdownComponent]
})
export class RoleDropdownModule { }
